import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';

export const ASSET_FAILURE_DIAGNOSTICS_QUERY_KEY = 'assetFailureDiagnostics';

export type FailureSubjectKind = 'asset' | 'report' | 'part-finder-report';

const lookupByKind = {
  asset: (tenantId: string, id: string) => api.assets.getAssetFailureDiagnostics(tenantId, id),
  report: (tenantId: string, id: string) => api.reports.getReportFailureDiagnostics(tenantId, id),
  'part-finder-report': (tenantId: string, id: string) =>
    api.tenants.getPartFinderReportFailureDiagnostics(tenantId, id),
};

export function useGetAssetFailureDiagnostics({
  assetId,
  kind = 'asset',
  enabled,
}: {
  assetId: string;
  kind?: FailureSubjectKind;
  enabled: boolean;
}) {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  return useQuery({
    queryKey: [ASSET_FAILURE_DIAGNOSTICS_QUERY_KEY, { tenantId, assetId, kind }],
    queryFn: async () => lookupByKind[kind](tenantId, assetId),
    select: data => data.data,
    enabled: enabled && !!tenantId && !!assetId,
    staleTime: Number.POSITIVE_INFINITY,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
